import Footer from './Footer';
import Header from './Header';
import Navigation from './Navigation';
import SideBarRight from './SideBarRight';
import {
  ErrorBoundary,
  getErrorMessage,
  type FallbackProps,
} from 'react-error-boundary';
import * as Sentry from '@sentry/react';
import UpperAdComponent from './UpperAdComponent';

function Fallback({ error, resetErrorBoundary }: FallbackProps) {
  Sentry.captureException(error);
  return (
    <div role='alert'>
      <p>Something went wrong:</p>
      <pre style={{ color: 'red' }}>{getErrorMessage(error)}</pre>
      <button onClick={resetErrorBoundary}>Retry</button>
    </div>
  );
}

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header />
      <UpperAdComponent />
      <Navigation />
      <div
        className='flex h-full w-full
         flex-col flex-wrap justify-center p-4'
      >
        <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>
      </div>
      <SideBarRight />
      <Footer />
    </>
  );
}
